import { render, staticRenderFns } from "./ipManagement.vue?vue&type=template&id=1209d962&scoped=true&"
import script from "./ipManagement.vue?vue&type=script&lang=js&"
export * from "./ipManagement.vue?vue&type=script&lang=js&"
import style0 from "./ipManagement.vue?vue&type=style&index=0&id=1209d962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1209d962",
  null
  
)

export default component.exports